import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import PopUp from '../../../../Shared/Popup/PopUp';
import errorIcon from '../../Pages/InstructionsPage/images/error-icon.svg';
import './GetQrCodeErrorPopUp.scss';

const GetQrCodeErrorPopUp = ({ show, onClose }) => (
    <PopUp
        showPopUp={show}
        onClose={onClose}
        footerBtn={{ text: 'הבנתי, תודה', onBtnClick: onClose }}
    >
        <div className='popup-get-qr-code-error'>
            <div className='popup-image'><Image src={errorIcon} /></div>
            <div className='popup-title'> קוד ההפעלה של ה-eSIM שלך <br />עדיין לא מוכן </div>
            <div className='popup-sub-title'> אפשר לנסות שנית בעוד מספר דקות </div>
        </div>
    </PopUp>
);

export default GetQrCodeErrorPopUp;
